<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>{{ title }} Configuración del Importador y el Lugar de Destino por Taric</h4>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos de la Configuración del Importador y el Lugar de Destino por Taric
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="intCodigoTaric">Código Taric</label>
                                        <input formControlName="CodigoTaric" name="CodigoTaric" class="form-control" minlength="4" maxlength="10" inputStyleClass="form-control" [ngClass]="displayFieldCss('CodigoTaric')" type="text" value="" pattern="^(?:\d{4}|\d{6}|\d{8}|\d{10})$">

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','required')">
                                            El Código Taric es obligatorio
                                        </div>

                                        <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','minlength')">
                                            El Código Taric debe tener al menos 4 números
                                        </div>-->

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','pattern')">
                                            El Código Taric debe ser numérico y estar compuesto de 4, 6, 8 o 10 dígitos
                                        </div>
                                    </div>

                                    <div class="form-group col-md-2"></div>

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpHigiene">Higiene</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="Higiene" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpChedPp">Ched PP</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="ChedPp" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpPcfCanariasSv">PCF Canarias SV</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="PcfCanariasSv" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
